import React from 'react';
import LoginSlider from '../shared/LoginSlider';
import FormCard from '../shared/FormCard';
import WhatsAppAuthHeader from './WhatsAppAuthHeader';
import WhatsAppSignIn from './WhatsAppSignIn';
import WhatsAppSignUp from './WhatsAppSignUp';
import { useIsMobile } from '../../../hooks/use-mobile';
import { useWhatsAppMode } from '../../../hooks/useWhatsAppMode';

export const WhatsAppAuthContainer = () => {
  const isMobile = useIsMobile();
  const [mode] = useWhatsAppMode();

  return (
    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', width: '100%', minHeight: '100vh', background: 'white' }}>
      {/* Left Side - Slider */}
      {!isMobile && (
      <div style={{ 
        flex: 1,
        minHeight: isMobile ? 'auto' : '100vh',
        minWidth: 0,
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch',
        padding: isMobile ? '24px 16px' : '80px 20px 40px 40px',
        background: 'linear-gradient(135deg, #052f26 0%, #0a4d3c 100%)',
        color: 'white',
        boxSizing: 'border-box',
        overflowX: 'hidden'
      }}>
        <div style={{ flex: 1, maxWidth: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Logo Section - Horizontal */}
          <div style={{ marginBottom: isMobile ? '24px' : '60px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img src="/prodyt.png" alt="Prodyt logo" style={{ width: isMobile ? '40px' : '48px', height: isMobile ? '40px' : '48px', borderRadius: '10px', objectFit: 'cover' }} />
            <h1 style={{ fontSize: isMobile ? '24px' : '28px', fontWeight: 'bold', margin: '0', color: 'white' }}>
              Prodyt
            </h1>
          </div>
          {/* Slider Section - Fill available height */}
          <div style={{ flex: 1, display: 'flex', alignItems: 'stretch', justifyContent: 'center', width: '100%' }}>
            <LoginSlider />
          </div>
        </div>
      </div>
      )}

      {/* Right Side - Auth Form */}
      <div style={{ 
        flex: 1, 
        minWidth: 0,
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isMobile ? '20px 16px 24px' : '40px',
        background: 'white',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        <div style={{ width: '100%', maxWidth: isMobile ? '100%' : '400px' }}>
          <FormCard>
            <WhatsAppAuthHeader />
            <div style={{ marginTop: '30px' }}>
              {mode === 'signIn' && <WhatsAppSignIn />}
              {mode === 'signUp' && <WhatsAppSignUp />}
            </div>
          </FormCard>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppAuthContainer;
